module.exports = __webpack_public_path__ + "00d6d1b1a0bca084bda253617d762bea.png";